import React, { useState, createContext, useContext } from 'react';
export type NotificationType = 'info' | 'success' | 'warning' | 'error' | 'urgent';
export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  date: Date;
  read: boolean;
  link?: string;
}
interface NotificationContextType {
  notifications: Notification[];
  unreadCount: number;
  addNotification: (type: NotificationType, title: string, message: string, link?: string) => void;
  markAsRead: (id: string) => void;
  clearAll: () => void;
}
const NotificationContext = createContext<NotificationContextType | undefined>(undefined);
export const NotificationProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [notifications, setNotifications] = useState<Notification[]>([{
    id: '1',
    type: 'urgent',
    title: 'Scadenza Contratto',
    message: 'Il contratto 24.001 scade tra 3 giorni',
    date: new Date(),
    read: false
  }, {
    id: '2',
    type: 'info',
    title: 'Nuovo Ticket',
    message: 'Ticket #45 assegnato a te',
    date: new Date(Date.now() - 86400000),
    read: false
  }]);
  const unreadCount = notifications.filter(n => !n.read).length;
  const addNotification = (type: NotificationType, title: string, message: string, link?: string) => {
    const newNotif: Notification = {
      id: Math.random().toString(36).substr(2, 9),
      type,
      title,
      message,
      date: new Date(),
      read: false,
      link
    };
    setNotifications(prev => [newNotif, ...prev]);
  };
  const markAsRead = (id: string) => {
    setNotifications(prev => prev.map(n => n.id === id ? {
      ...n,
      read: true
    } : n));
  };
  const clearAll = () => {
    setNotifications([]);
  };
  return <NotificationContext.Provider value={{
    notifications,
    unreadCount,
    addNotification,
    markAsRead,
    clearAll
  }} data-id="element-2127" data-mp="q7ii92aqulvj">
      {children}
    </NotificationContext.Provider>;
};
export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) throw new Error('useNotifications must be used within NotificationProvider');
  return context;
};